import styled from "styled-components";
import theme from "../../style/theme";

interface Props {
  width: string;
  height: string;
  text: string;
  onClick: () => void;
  sx?: any;
  disabled?: boolean;
}

export const OutlinedBlackButton: React.FC<Props> = ({
  width,
  height,
  text,
  onClick,
  sx,
  disabled,
}) => {
  return (
    <OutlinedButton
      style={sx}
      width={width}
      height={height}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </OutlinedButton>
  );
};

interface OutlinedButtonProps {
  width: string;
  height: string;
  disabled?: boolean;
}

const OutlinedButton = styled.button<OutlinedButtonProps>`
  width: ${(props) => props.width}};
  height: ${(props) => props.height}};
  background: ${(props) =>
    props.disabled
      ? theme.palette.primitives.gray50
      : theme.palette.primitives.white};
  border: 1px solid  ${(props) =>
    props.disabled
      ? theme.palette.primitives.gray300
      : theme.palette.primitives.black};
  border-radius: 4px;
  font-style: normal;
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.063rem;
  color: ${(props) =>
    props.disabled
      ? theme.palette.primitives.gray300
      : theme.palette.primitives.gray800};
  cursor: pointer;
`;
